// extracted by mini-css-extract-plugin
export default {"container":"container--mp-cJDnT","complete":"complete--mp-oOQkg","image":"image--mp-cr7FP","reduced":"reduced--mp-Kf4Mh","modalInfoContainer":"modalInfoContainer--mp-jHEPA"};